
import makerjs from "makerjs";
function C35(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,R2 = Param[1].param,R1 = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       w = W * 1 * myZoom,       
       r2 = R2 * 1 * myZoom,       
       r1 = R1 * 1 * myZoom,       
      
       //hd=r-l,
      //  hd=Math.sqrt(s1*s1-(b/2*b/2)), hh=h-s1+hd,
      //  x0 = 0, x1 = 0, x2 = b, x3 = b, y0 = 0, y1 = hh, y2 = hh, y3 = 0,
       /**假设长半轴为ry 短半轴为 rx 焦点离顶点距离为t
        * rx=r,  c=ry-t a=ry  b=rx=r  c*c=a*a-b*b
        * 求 ry=a=(t*t-r*r)/2*t  
       * */
      aa=r2*r2/(2*r1),
      rx=r2,ry=Number(r1/2)+Number(aa),
      h = 2*ry,
     // w = 2*rx,
       glassH =h, glassW = w;
       if (w !== 0) {
        var TxtW ="W="+ W;
    }  if (r1 !== 0) {
     var TxtR1 = "R1="+R1;
   }    if (r2 !== 0) {
    var TxtR2 = "R2="+R2;
  }
  console.log("rx,ry,h,w,aa=====",rx,ry,h,w,aa);
  // var myEgGapAEllipse=new makerjs.models.Ellipse(rx, ry);
  var drawAbnormalShapeC35=new makerjs.models.Ellipse(rx, ry);
  //  var drawAbnormalShapeC35 = {
  //      paths: {
        
  //       "EllipseArc": makerjs.models.Ellipse(2*t, 2*r),
  //      }
  //  };
   var drawAbnormalShapeC35MarkW = {
       paths: {
        "bottomLine": new makerjs.paths.Line([-w/2, -ry-markShift], [w/2, -ry-markShift]),        
        "RightShortUpline": new makerjs.paths.Line([-w/2, 0-ry], [-w/2, 0-ry-2*markShift]),
        "RightShortDnline": new makerjs.paths.Line([w/2, 0-ry], [w/2, 0-ry-2*markShift]),
       }  
   };
   var drawAbnormalShapeC35MarkR2 = {
       paths: {
        "RightLine": new makerjs.paths.Line([-r2, 0], [0, 0]),
       }
   };
   var drawAbnormalShapeC35MarkR1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([0, ry], [0, ry-r1]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC35MarkW, TxtW,  [-w/2, -ry-2*markShift], [w/2, -ry-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC35MarkR2, TxtR2,  [0+markShift, 0], [0+3*markShift, 0]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC35MarkR1, TxtR1, [0-markShift, ry-r1-markShift], [0+2*markShift, ry-r1-markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeC35: drawAbnormalShapeC35,
      }
    };
  markers={
      models: {
        drawAbnormalShapeC35: drawAbnormalShapeC35,
        drawAbnormalShapeC35MarkW:drawAbnormalShapeC35MarkW,
        drawAbnormalShapeC35MarkR1:drawAbnormalShapeC35MarkR1,
        drawAbnormalShapeC35MarkR2:drawAbnormalShapeC35MarkR2,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C35;